import { DomainConf } from "@wwg/domain-conf";

/**
 * Define configurations here to be loaded based on
 * which domain the app is being served from.
 */
const env = new DomainConf()
  .defaults({
    lang: "en",
    dateFormat: "MMMM D[,] YYYY",
    dateTimeFormat: "MMMM D[,] YYYY [at] h[:]mm a",
    vcsMonthFormat: "MMMM YYYY",
    googleAnalyticsId: "G-6Y9MPZQ77T",
  })
  .forDomain("localhost", {
    envName: "dev",
    // apiBase: "http://localhost:3750/api",
    apiBase: "https://dev-api.wwdb.com/v1/contacts",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
    shouldShowGivenBook: true,
    localDevMode: true, // Set to true to enable local login for developers.
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center-dev.wwdb.com",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
  })

  .forDomain("contacts-dev.wwdb.com", {
    envName: "dev",
    apiBase: "https://dev-api.wwdb.com/v1/contacts",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
    rootDomain: ".wwdb.com",
    shouldShowGivenBook: true,
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center-dev.wwdb.com",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
  })
  .forDomain("contacts.wwdb.dev", {
    envName: "dev",
    apiBase: "https://api.wwdb.com/v1/contacts",
    coreApiUrl: "https://api.wwdb.com/v1/core/",
    rootDomain: ".wwdb.com",
    shouldShowGivenBook: true,
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center-dev.wwdb.com",
    helpUrl: "https://app-help-web.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup.wwdb.com/",
  })
  .forDomain("app-contacts-web-dev.wwdb.com", {
    envName: "dev",
    apiBase: "https://dev-api.wwdb.com/v1/contacts",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
    rootDomain: ".wwdb.com",
    shouldShowGivenBook: true,
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center-dev.wwdb.com",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
  })
  .forDomain("app-contacts-web-staging.wwdb.com", {
    envName: "staging",
    apiBase: "https://api-staging.wwdb.com/v1/contacts",
    coreApiUrl: "https://api-staging.wwdb.com/v1/core/",
    rootDomain: ".wwdb.com",
    shouldShowGivenBook: true,
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center-staging.wwdb.com",
    helpUrl: "https://app-help-web.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup.wwdb.com/",
  })
  .forDomain("app-contacts-web.wwdb.com", {
    envName: "production",
    apiBase: "https://api.wwdb.com/v1/contacts",
    coreApiUrl: "https://api.wwdb.com/v1/core/",
    rootDomain: ".wwdb.com",
    shouldShowGivenBook: true,
    WEB_APP_COUNTRY: "US",
    ideaCenterUrl: "https://idea-center.wwdb.com/",
    helpUrl: "https://app-help-web.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup.wwdb.com/",
  })
  // Australia & New Zealand
  .forDomain("app-contacts-web-dev.wwdb.com.au", {
    envName: "dev",
    apiBase: "https://app-contacts-api-dev.wwdb.com.au/api",
    coreApiUrl: "https://app-core-web-dev.wwdb.com.au",
    rootDomain: ".wwdb.com.au",
    shouldShowGivenBook: false,
    WEB_APP_COUNTRY: "AU",
    ideaCenterUrl: "https://app-profile-web-dev.wwdb.com.au/verification",
    helpUrl: "https://app-help-web-dev.wwdb.com.au/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com.au",
    signUp: "https://signup-dev.wwdb.com.au/",
  })
  .forDomain("app-contacts-web-staging.wwdb.com.au", {
    envName: "staging",
    apiBase: "https://app-contacts-api-staging.wwdb.com.au/api",
    coreApiUrl: "https://app-core-web-staging.wwdb.com.au",
    rootDomain: ".wwdb.com.au",
    shouldShowGivenBook: false,
    WEB_APP_COUNTRY: "AU",
    ideaCenterUrl: "https://app-profile-web.wwdb.com.au/verification",
    helpUrl: "https://app-help-web.wwdb.com.au/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com.au",
    signUp: "https://signup.wwdb.com.au/",
  })
  .forDomain("app-contacts-web.wwdb.com.au", {
    envName: "production",
    apiBase: "https://app-contacts-api.wwdb.com.au/api",
    coreApiUrl: "https://app-core-web.wwdb.com.au",
    rootDomain: ".wwdb.com.au",
    shouldShowGivenBook: false,
    WEB_APP_COUNTRY: "AU",
    ideaCenterUrl: "https://app-profile-web.wwdb.com.au/verification",
    helpUrl: "https://app-help-web.wwdb.com.au/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com.au",
    signUp: "https://signup.wwdb.com.au/",
  });

// Export the selected configuration from this file. You can import this wherever you need to use it.
export default env.current;
